import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { OneNote } from "./types.js";
addProp(_User, "onenote", OneNote);
//# sourceMappingURL=users.js.map